import {BlueText, PinkText, SectionHeader, SectionSubHeader, SectionText} from "../../../components/DesignSystem/Articles/Articles";
import React from "react";
import {Collapse, Row, Col} from "antd";

export const FAQ = () => {

    const items = [
        {
            key: '1',
            label: 'What files does apimoon supports',
            children: 'Apimoon supports a wide range of file formats including CSV, Excel, JSON, Parquet, and TSV. You can easily upload and analyze your data in these formats.',
        },
        {
            key: '2',
            label: 'Is there a limit on the size of files I can upload?',
            children: 'Yes, there is a limit on the size of files you can upload. It is based on your subscription plan.',
        },
        {
            key: '3',
            label: 'How do I upgrade or downgrade my plan?',
            children: 'You can upgrade or downgrade your plan at any time through your account settings. Simply go to the billing section and choose the plan that suits your needs.',
        },
        {
            key: '4',
            label: 'How do get a receipt for my payment?',
            children: 'The receipt for your payment will be sent to your registered email address. You can also download it from the billing section of your account settings.',
        },
        {
            key: '5',
            label: 'How do I cancel my subscription?',
            children: 'To cancel your subscription, go to your account settings and navigate to the billing section. There you will find the option to cancel your subscription. Please note that cancellation will take effect at the end of your current billing cycle.',
        }
    ];

    return <>
        <SectionHeader>FAQ</SectionHeader>
        <SectionSubHeader>Frequently Asked <BlueText>Questions</BlueText>
        </SectionSubHeader>
        <SectionText>
            Everything you need to know about apimoon</SectionText>

        <Row align={"center"} >
            <Col sm={18}>
                <Collapse items={items} bordered={false} style={{fontSize: '18px', fontWeight: '600'}} />
            </Col>
        </Row>

    </>

}